import { ChangeDetectionStrategy, Component, HostListener, OnInit, inject } from '@angular/core';

import { DeviceService, WINDOW } from '@frontend/vanilla/core';
import { LetDirective } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseDetailsTermsConditionsComponent } from '../../../base-details/base-details-terms-conditions/base-details-terms-conditions.component';
import { BaseDetailsContent } from '../../../base-details/base-details.model';
import { PreRequisite } from '../../common/models/pre-requisite/pre-requisite';
import { PreRequisiteProgress } from '../../common/models/pre-requisite/pre-requisite-progress';
import { PreRequisiteComponent } from '../../common/pre-requisite/pre-requisite.component';
import { PromoRewardsComponent } from '../../common/rewards/rewards.component';
import { commonContentMessages, rewardsContent, targetPromoContent } from '../../common/store/target-promotion.selectors';
import { PlayerActivityDetails } from '../models/player-activity-details';
import { PlayerActivityContentStoreModel } from '../models/player-activity-store-model';
import { playerActivityDetails, preRequisite, totalWagered } from '../store/player-activity.selectors';
import { CriteriaCarouselComponent } from './criteria-carousel/criteria-carousel.component';
import { PlayerActivityCurrentlyAchievedComponent } from './player-activity-currently-achieved/player-activity-currently-achieved.component';

interface PlayerActivityMyProgressViewModel {
    baseDetailsContent: BaseDetailsContent;
    commonContentMessages: { [key: string]: string };
    preRequisite: PreRequisite;
    totalWagered: PreRequisiteProgress;
    playerActivityContent: PlayerActivityContentStoreModel;
}

@Component({
    selector: 'player-activity-my-progress',
    templateUrl: './player-activity-my-progress.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        LetDirective,
        CriteriaCarouselComponent,
        PlayerActivityCurrentlyAchievedComponent,
        BaseDetailsTermsConditionsComponent,
        PreRequisiteComponent,
        PromoRewardsComponent,
    ],
})
export class PlayerActivityMyProgressComponent implements OnInit {
    desktop: boolean;

    rewardsContent$ = this.store.select(rewardsContent);

    vm$: Observable<PlayerActivityMyProgressViewModel> = combineLatest([
        this.store.select(targetPromoContent),
        this.store.select(commonContentMessages),
        this.store.select(preRequisite),
        this.store.select(totalWagered),
        this.store.select(playerActivityDetails),
    ]).pipe(
        map(([targetPromoContent, commonContentMessages, preRequisite, totalWagered, playerActivityDetails]) => {
            return {
                baseDetailsContent: targetPromoContent,
                commonContentMessages: commonContentMessages ?? {},
                preRequisite,
                totalWagered,
                playerActivityContent: playerActivityDetails?.playerActivityContent,
            };
        }),
    );

    readonly #window = inject(WINDOW);

    constructor(
        private deviceService: DeviceService,
        private store: Store<{ playerActivityModuleData: PlayerActivityDetails }>,
    ) {}

    ngOnInit() {
        this.desktop = !this.deviceService.isMobile;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.desktop = this.#window.innerWidth > 600;
    }
}
